var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.91 16.0399V13.0699C29.91 6.78995 24.8 1.68994 18.53 1.68994C12.26 1.68994 7.15001 6.79995 7.15001 13.0699V16.0399C4.07001 16.5099 1.70001 19.1799 1.70001 22.3899V37.4499C1.70001 40.9899 4.58001 43.8799 8.13001 43.8799H28.94C32.48 43.8799 35.37 40.9999 35.37 37.4499V22.3899C35.37 19.1799 33 16.5099 29.92 16.0399H29.91Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.97H13.55V13.17C13.55 10.43 15.78 8.19995 18.52 8.19995C21.26 8.19995 23.49 10.43 23.49 13.17V15.97H23.5Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.53 31.7999C19.3971 31.7999 20.1 31.097 20.1 30.2299C20.1 29.3628 19.3971 28.6599 18.53 28.6599C17.6629 28.6599 16.96 29.3628 16.96 30.2299C16.96 31.097 17.6629 31.7999 18.53 31.7999Z",
    fill: "#00C9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ffdc2d0d538360b68ea65aa94414a5ec.svg";
export { ForwardRef as ReactComponent };